import { useCrud } from "hooks";
import { get } from "lodash";
import { useParams } from "react-router-dom";
import UploadSmsStatsFile from "./UploadSmsStatsFile";

export default function SmsStatsFile() {
   const { recurrenceId } = useParams();
   const {
      data: statsFileData,
      isLoading,
      mutate,
   } = useCrud({ url: `/background-jobs?payload->recurrence_id=${recurrenceId}&type=process_sms_statistics_file` });

   function getStatusClass(status: string) {
      switch (status) {
         case "pending":
            return "text-orange-600 bg-orange-100 border-yellow-600 ";
         case "running":
            return "text-yellow-600 bg-yellow-100 border-yellow-600 ";
         case "completed":
            return "text-green-600 bg-green-100 border-green-600 ";
         case "failed":
            return "text-red-600 bg-red-100 border-red-600 ";
         default:
            return "";
      }
   }
   if (isLoading) {
      return <div>Loading...</div>;
   }
   if (!statsFileData?.data) {
      return <UploadSmsStatsFile onSuccess={mutate} />;
   }

   return (
      <div className="p-4 border border-gray-300 rounded-md">
         Fichier de statistiques téléchargé{" "}
         <span className={`${getStatusClass(get(statsFileData, "data.status", ""))} capitalize border rounded-full text-xs px-2 py-0.5`}>
            {get(statsFileData, "data.status")}
         </span>
         <br />
         <span className="text-sm text-gray-600">
            Fichier : {get(statsFileData, "data.payload.file_name")} <br />
            Téléchargé le : {get(statsFileData, "data.created_at")} <br />
         </span>
      </div>
   );
}
